<template>
  <div>
    <div style="height:55px" class="hidden-md-and-up"></div>
    <v-layout row wrap>
      <v-flex lg12 md12 xs12>
        <v-tabs
          height="60"
          centered
          icons-and-text
          color="primary lighten-3"
          slider-color="orange"
          grow
          dark
        >
          <v-tab>
            Busqueda de Abogadas(os)
            <v-icon>person</v-icon>
          </v-tab>
          <v-tab-item>
            <v-card color="transparent" class="elevation-0">
              <busqueda-abogado />
            </v-card>
          </v-tab-item>

          <v-tab>
            Busqueda de Sociedades Civiles
            <v-icon>group</v-icon>
          </v-tab>
          <v-tab-item>
            <v-card color="transparent" class="elevation-0">
              <busqueda-sociedad />
            </v-card>
          </v-tab-item>
        </v-tabs>
      </v-flex>
    </v-layout>
  </div>
</template>
<script>
export default {
  components:{
    "busqueda-abogado":()=>import("@/components/Busqueda/Abogado"),
    "busqueda-sociedad":()=>import("@/components/Busqueda/Sociedad")
  }
};
</script>
<style>
.texto-principal {
  background-image: url("../../assets/rpaOpacidad.png") !important;
  background-size: 80% !important;
  background-position: center;
}
.v-tabs__slider {
    height: 5px !important;
    width: 100%;
}
</style>





// WEBPACK FOOTER //
// src/components/Busqueda/Busqueda.vue